import React, { useEffect, useState } from 'react';
import { TouchableOpacity } from 'react-native';
import { Icon } from 'react-native-paper';
import { HStack, Text } from 'native-base';
import { format } from 'date-fns';
import { useLocationTrackingContext } from '../../context/LocationTrackingContext';
import { SCREEN_NAMES } from '../../utils/constant';
import { getActivePause, pauseEndOf } from '../../utils/tripPauses';

const COLOR_ONGOING = '#16a34a';
const COLOR_PAUSED = '#f97316';

/** Shortcut under the top bar, for a driver whose trip is in progress. */
function ActiveTripBanner({ navigation, hidden }) {
  const { activeTrip } = useLocationTrackingContext();

  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(timer);
  }, []);

  if (!activeTrip || hidden) return null;

  const activePause = getActivePause(activeTrip.pauses, now);
  const label = activePause
    ? `En pause jusqu'à ${format(new Date(pauseEndOf(activePause)), 'HH:mm')}`
    : 'Trajet en cours';

  return (
    <TouchableOpacity
      style={{ backgroundColor: activePause ? COLOR_PAUSED : COLOR_ONGOING }}
      onPress={() => navigation.navigate(SCREEN_NAMES.DASHBOARD, {
        screen: SCREEN_NAMES.TRIP_TRACKING,
        params: { tripId: activeTrip.id, eventId: activeTrip.event.id },
      })}
    >
      <HStack justifyContent="center" alignItems="center" space={2} px={3} py={2}>
        <Text color="white" fontSize="sm" fontWeight="bold" isTruncated flexShrink={1}>
          {`${label} · ${activeTrip.departureLocation} → ${activeTrip.arrivalLocation}`}
        </Text>
        <Icon source="eye-outline" size={20} color="white" />
      </HStack>
    </TouchableOpacity>
  );
}

export default ActiveTripBanner;
